import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FormHelperText from '@material-ui/core/FormHelperText';
import withStyles from '@material-ui/core/styles/withStyles';

import { PASSWORD_HINT, PASSWORD_ERROR } from '../utils/password';


const styles = () => ({
    root: {
        marginTop: 8,
        marginBottom: 8
    },
    label: {
        display: 'block',
        fontSize: 14,
        fontWeight: 500,
        color: '#444',
        marginBottom: 6,
        marginTop: 8
    },
    hint: {
        fontSize: 11,
        color: '#888',
        fontWeight: 400,
        marginLeft: 4
    },
    inputRoot: {
        borderRadius: 8,
        backgroundColor: '#fff',
        '&:hover:not($disabled):not($error):not($focused) $notchedOutline': {
            borderColor: '#d4dbe0'
        }
    },
    notchedOutline: {
        borderWidth: 1,
        borderColor: '#d4dbe0'
    },
    focused: {
        '& $notchedOutline': {
            borderColor: '#0BADEC',
            borderWidth: 1
        }
    },
    error: {
        '& $notchedOutline': {
            borderColor: '#f44336'
        }
    },
    disabled: {},
    input: {
        padding: '12px 14px',
        fontSize: 15
    }
});


function PasswordInput({
    label,
    value,
    onChange,
    error,
    disabled,
    fullWidth,
    autoComplete,
    helperText,
    classes
}) {
    return (
        <FormControl fullWidth={fullWidth} error={error} disabled={disabled} className={classes.root}>
            <label className={classes.label}>
                {label}
                <span className={classes.hint}>{PASSWORD_HINT}</span>
            </label>
            <OutlinedInput
                type="password"
                value={value}
                onChange={onChange}
                disabled={disabled}
                autoComplete={autoComplete}
                fullWidth={fullWidth}
                classes={{
                    root: classes.inputRoot,
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                    error: classes.error,
                    disabled: classes.disabled,
                    input: classes.input
                }}
                inputProps={{
                    minLength: 6,
                    maxLength: 12,
                    pattern: '[a-z0-9]{6,12}'
                }}
                labelWidth={0}
            />
            {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
        </FormControl>
    );
}

PasswordInput.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.bool,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    autoComplete: PropTypes.string,
    helperText: PropTypes.string,
    classes: PropTypes.object.isRequired
};

PasswordInput.defaultProps = {
    error: false,
    disabled: false,
    fullWidth: true,
    autoComplete: 'new-password',
    helperText: ''
};


export default withStyles(styles)(PasswordInput);
export { PASSWORD_HINT, PASSWORD_ERROR };
